import React, { useState } from "react";
import { Layout } from "antd";
import { Outlet, useNavigate } from "react-router-dom";
import AppHeader from "./Header";
import Sidebar from "./Sidebar";
import { signOut } from "firebase/auth";
import { auth } from "../../../firebase/firebaseConfig";


const { Content } = Layout;

const MainLayout = () => {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();

    const handleLogout = () => {
        signOut(auth);
        navigate("/login");
    };

    return (
        <Layout style={{ minHeight: "100vh", direction: "rtl" }}>
            <Sidebar collapsed={collapsed} />
            <Layout>
                <AppHeader
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                    onLogout={handleLogout}
                />
                <Content style={{ margin: "10px", background: "#fff", padding: "10px" }}>
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default MainLayout;
